var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginPageLayoutCard',[_c('ResetPinCardHeader'),_c('resetPinCardForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }